import React from "react";

import SimpleModalWithCenteredButtons from "@src/sharedComponents/Modal/SimpleModalWithCenteredButtons/SimpleModalWithCenteredButtons";

interface Props {
  title?: string;
  text?: string;
  deleteButtonText: string;
  onDelete: () => void;
  onClose: () => void;
  isOpen?: boolean;
}

const DeleteModal: React.FC<Props> = ({
  title = "Delete",
  text = "Are you sure you want to delete this item?",
  deleteButtonText,
  onDelete,
  onClose,
  isOpen = true,
}: Props) => {
  return (
    <SimpleModalWithCenteredButtons
      isOpen={isOpen}
      title={title}
      text={text}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
      }}
      primaryButton={{
        text: deleteButtonText,
        onClick: onDelete,
      }}
      onClose={onClose}
    />
  );
};

export default DeleteModal;
